import styled from "styled-components";
import { colors } from "../../styles/variables";

export const StyledSearchOverlay = styled.div`
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100% - 80px);
  background-color: ${colors.black};
  opacity: 0.6;
  margin-top: -1px;
  z-index: 999;
`;

export const StyledSearchContainer = styled.div`
  position: fixed;
  top: var(--header-height, 70px);
  left: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: -1px;
`;

export const StyledSearchContent = styled.div`
  width: 100%;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.gray100};
  position: relative;
  margin-top: 0;
`;

export const StyledSearchInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px;
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 3px;
  height: 40px;
`;

export const StyledSearchIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  position: relative;

  svg {
    width: 20px;
    height: 20px;

    * {
      stroke: ${colors.gray900};
    }
  }
`;

export const StyledInput = styled.input`
  flex: 1;
  border: none;
  font-size: 16px;
  line-height: 1.2;
  color: ${colors.gray900};
  padding: 0;
  margin: 0;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${colors.gray900};
  }
`;

export const StyledClearButton = styled.button`
  font-size: 16px;
  line-height: 1.2;
  color: ${colors.blue};
  background: none;
  border: none;
  padding: 0 10px;
  cursor: pointer;
  min-width: 111px;
`;

export const StyledArrowButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;

  svg path {
    fill: ${colors.blue};
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const StyledMainSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px;
`;

export const StyledProductCard = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px;
  min-width: 146px;
  width: 146px;
  height: 176px;
  background-color: ${colors.gray100};
  border-radius: 4px;
  text-decoration: none;
  flex-shrink: 0;

  &:hover {
    background-color: ${colors.gray100};
  }
`;

export const StyledProductImage = styled.div`
  width: 100%;
  height: 100px;
  position: relative;
`;

export const StyledProductName = styled.span`
  font-size: 13px;
  line-height: 1.2;
  color: ${colors.gray900};
  text-align: left;
  width: 100%;
`;

export const StyledProductPrice = styled.span`
  font-size: 13px;
  line-height: 1.2;
  color: ${colors.gray600};
  text-align: left;
  width: 100%;
  display: none; /* removing from UI for now, until we get a handle on long product titles */
`;

export const StyledCloseContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  position: fixed;
  width: 100%;
  margin: auto;
`;

export const StyledCloseButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1.2;
  color: ${colors.white};
`;

export const StyledSpinnerWrapper = styled.div`
  margin: 50px auto;
  width: 150px;
`;

export const StyledErrorMessage = styled.div`
  color: ${colors.red};
  font-size: 14px;
  padding: 16px;
  text-align: center;
`;

export const StyledSwiperWrapper = styled.div`
  margin-bottom: 25px;
  position: relative;

  .swiper-slide {
    width: 160px;
  }

  .swiper-button-next,
  .swiper-button-prev {
    color: ${colors.blue};
    background-color: ${colors.white};
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    &::after {
      font-size: 16px;
      font-weight: bold;
    }

    &.swiper-button-disabled {
      opacity: 0.35;
    }
  }

  .swiper-button-next {
    right: 10px;
  }

  .swiper-button-prev {
    left: 10px;
  }
`;
